import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// 即时通讯订单提醒
const remind = {
	num:0
}

const state = {
	remind,
	// 最近一次 WebSocket 订单事件，供各页面监听实时刷新
	// { type, orderId, orderNum, content, time, key }
	lastOrderEvent: null,
	// 全局消息通知中心列表（最多保留 50 条）
	notifyList: [],
	// 未读消息数
	notifyUnread: 0,
	// WebSocket 连接状态：'connected' | 'disconnected' | 'reconnecting'
	wsStatus: 'disconnected'
}

export default new Vuex.Store({
	state,
	mutations:{
		// 即时通讯订单提醒
		order_remind(state,num){
			// console.log(num)
			state.remind = {num}
		},
		// 记录最新的订单 WebSocket 事件，触发订阅页面自动刷新
		setOrderEvent(state, evt){
			state.lastOrderEvent = evt
		},
		// 新增一条全局通知（最新的在最前）
		pushNotify(state, item){
			state.notifyList.unshift(item)
			if (state.notifyList.length > 50) {
				state.notifyList = state.notifyList.slice(0, 50)
			}
			state.notifyUnread = state.notifyUnread + 1
		},
		// 全部标为已读
		markAllRead(state){
			state.notifyUnread = 0
		},
		// 清空全部通知
		clearNotify(state){
			state.notifyList = []
			state.notifyUnread = 0
		},
		// WebSocket 连接状态变更
		setWsStatus(state, status){
			state.wsStatus = status
		}
	}
})